const format = (num, language) => num ? num.toLocaleString(language ? language : "it") : num;

export default format;
